import { Bullseye, PageSection, PageSectionVariants } from '@patternfly/react-core';
import React from 'react';
import { User } from '../../types/models';
import { ClientlessOnboarding } from './ClientlessOnboarding';
import { JoinPending } from './JoinPending';

export interface OrganizationOnboardingProps {
  user: User;
  // Threaded from authenticatedApp (fetchUserData) and passed to the clientless branch, whose
  // create form re-fetches the user after a successful create so the gate re-evaluates.
  // JoinPending wires it in Step 5.
  refreshUser: () => Promise<void>;
}

/**
 * Gate screen shown instead of the routed app (AppLayout) for any non-active user.
 * Routes by `onboarding_state` and renders each branch inside a shared centered shell
 * (PageSection + Bullseye) mirroring the Unauthenticated screen; each branch supplies its
 * own Card as the centered content.
 */
export function OrganizationOnboarding({ user, refreshUser }: OrganizationOnboardingProps) {
  let content: React.ReactNode = null;
  switch (user.onboarding_state) {
    case 'clientless':
      content = <ClientlessOnboarding refreshUser={refreshUser} />;
      break;
    case 'join_pending':
      content = <JoinPending clientID={user.clientID} refreshUser={refreshUser} />;
      break;
    default:
      // 'active' is gated upstream in authenticatedApp and never reaches this component.
      break;
  }

  return (
    <PageSection variant={PageSectionVariants.default}>
      <Bullseye>{content}</Bullseye>
    </PageSection>
  );
}
